'use client';

import { FC, useEffect, useState } from 'react';

import { Address } from '@ravago/shared/page-data/models/elements/address.model';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Divider } from '@ravago/shared/radiance/components/divider/components/Divider/Divider';
import { Paper } from '@ravago/shared/radiance/components/paper/components/Paper/Paper';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { MultiLineText } from '@ravago/shared/radiance/components/typography/components/MultiLineText/MultiLineText';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   deliveryAddress: Address;
   legalAddress: Address;
   locale: string;
   deliveryDate: Date;
}

export const CheckoutSuccessOrderInfo: FC<Props> = ({ deliveryAddress, legalAddress, locale, deliveryDate }) => {
   const translate = useTranslations();
   const [formattedDeliveryDate, setFormattedDeliveryDate] = useState<string>('');

   useEffect(() => {
      setFormattedDeliveryDate(
         deliveryDate.toLocaleDateString(locale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
         })
      );
   }, [deliveryDate, locale]);

   return (
      <Paper>
         <Box direction="column" gap="sm">
            <Typography component="h3" variant="heading-4">
               {translate('shopping-cart.order-information')}
            </Typography>
            <Divider />
            <Table stroked="horizontal">
               <TableBody>
                  <TableRow>
                     <TableCell>
                        <Typography variant="body-highlight"> {translate('shopping-cart.delivery-date')}</Typography>
                     </TableCell>
                     <TableCell>{formattedDeliveryDate}</TableCell>
                  </TableRow>
                  <TableRow>
                     <TableCell>
                        <Typography variant="body-highlight">{translate('shopping-cart.billing-address')} </Typography>
                     </TableCell>
                     <TableCell>
                        <MultiLineText text={legalAddress.htmlFormat} lineBreak="<br>" />
                     </TableCell>
                  </TableRow>
                  <TableRow>
                     <TableCell>
                        <Typography variant="body-highlight"> {translate('shopping-cart.delivery-address')} </Typography>
                     </TableCell>
                     <TableCell>
                        <MultiLineText text={deliveryAddress.htmlFormat} lineBreak="<br>" />
                     </TableCell>
                  </TableRow>
               </TableBody>
            </Table>
         </Box>
      </Paper>
   );
};
